import React from 'react';
import styled from "styled-components";
import { timeBeforeAlertMessageDisappearsMilliseconds } from '../../configuration';

const DismissButtonContainer = styled.div`
  right: 10px;
  top: 50%;
  margin-top: -8px;
`;

const NotificationBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.isWarning ? "#d8dc6a" : "#669933"};
  color: #ffffff;
  padding: 7px;
  border-radius: 3px;
  width: 100%;
  margin-bottom: 5px;
  // text-align: ${props => props.isAlert ? "center" : "left"}
  text-align: left;
  cursor: pointer;
  opacity: ${props => props.opacity};
`;

const NotificationTitle = styled.div`
  font-weight: bold;
`;

class Notification extends React.Component {
  state = {
    opacity: 1
  };
  componentDidMount() {
    if (this.props.notificationData.isAlert) {
      setTimeout(this.fadeOut,timeBeforeAlertMessageDisappearsMilliseconds);
    }
  }
  fadeOut = () => {
    let fade = setInterval(async () => {
      let newOpacity = this.state.opacity - 0.05;
      await this.setState({opacity: newOpacity})
    },50);

    const props = this.props;

    setTimeout(function() {
      // console.log("Interval cleared")
      clearInterval(fade);
      props.removeNotification(props.notificationData.id);
    }, 1000);
  };
  render() {
    return (
      <NotificationBox
        opacity={this.state.opacity}
        isAlert={this.props.notificationData.isAlert}
        isWarning={this.props.notificationData.isWarning}
        onClick={() => this.props.removeNotification(this.props.notificationData.id)}
      >
        <div>
          {this.props.notificationData.title !== "" && <NotificationTitle>{this.props.notificationData.title}</NotificationTitle>}
          {this.props.notificationData.body !== "" && this.props.notificationData.body}
        </div>
        {
          !this.props.notificationData.isAlert
          &&
          <DismissButtonContainer>&times;</DismissButtonContainer>
        }
      </NotificationBox>
    )
  }
}

export default Notification;
